export enum Bank {
  ReceiptPaymentTypeId = "ReceiptPaymentTypeId",
  AccountOwner = "AccountOwner",
  Iban = "Iban",
  FractionationTypeId = "FractionationTypeId",
  CollectionDate = "CollectionDate",
}
